import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import {
  Textarea, TextField, Grid, Label,
} from '@printdeal/ui-library';
import { SelectorContent } from '@printdeal/product-selector';
import Selection from '../Selection';

export interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  remarks: string;
}

interface Props {
  formik: FormikProps<FormValues>;
  product: SelectorContent['product'];
  shouldUserAddContactInfo: boolean;
  contentfulId: string;
}

const validate = (
  errors: FormikErrors<FormValues>, touched: FormikTouched<FormValues>, fieldName: keyof FormValues,
) => {
  if (errors[fieldName] && touched[fieldName]) {
    return 'error';
  }
  if (!errors[fieldName] && touched[fieldName]) {
    return 'success';
  }
  return undefined;
};

const InventoryCheckQuoteForm = ({
  formik: {
    getFieldProps, errors, touched,
  },
  product,
  shouldUserAddContactInfo,
}: Props) => {
  const intl = useIntl();

  return (
    <>
      {shouldUserAddContactInfo && (
        <Grid className="pd-gap-6">
          <Grid.Item>
            <TextField
              {...getFieldProps('firstName')}
              id="firstName"
              name="firstName"
              label={intl.formatMessage({ id: 'generic.form.label.firstName', defaultMessage: 'First name' })}
              required
              validation={validate(errors, touched, 'firstName')}
            />
          </Grid.Item>
          <Grid.Item>
            <TextField
              {...getFieldProps('lastName')}
              id="lastName"
              name="lastName"
              required
              label={intl.formatMessage({ id: 'generic.form.label.lastName', defaultMessage: 'Last name' })}
              validation={validate(errors, touched, 'lastName')}
            />
          </Grid.Item>
          <Grid.Item>
            <TextField
              {...getFieldProps('email')}
              id="email"
              name="email"
              required
              type="email"
              label={intl.formatMessage({ id: 'generic.form.label.email', defaultMessage: 'Email address' })}
              validation={validate(errors, touched, 'email')}
            />
          </Grid.Item>
          <Grid.Item>
            <TextField
              {...getFieldProps('phone')}
              id="phone"
              name="phone"
              required
              type="tel"
              label={intl.formatMessage({ id: 'generic.form.label.phone', defaultMessage: 'Phone number' })}
              validation={validate(errors, touched, 'phone')}
            />
          </Grid.Item>
          <Grid.Item>
            <Label>
              <FormattedMessage id="product.unavailable.quoteModal.yourSelection" defaultMessage="Your selection" />
            </Label>
            <Selection product={product} className="pd-my-3" />
          </Grid.Item>
          <Label>
            <FormattedMessage id="generic.form.label.remarks" defaultMessage="Remarks" />
          </Label>
          <Textarea
            {...getFieldProps('remarks')}
            id="remarks"
            name="remarks"
            required
            validation={validate(errors, touched, 'remarks')}
          />
          <Grid.Item />
        </Grid>
      )}
    </>
  );
};

export default InventoryCheckQuoteForm;
